import * as React from 'react';
import type { SVGProps } from 'react';
const SvgWarningFullOrange = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    aria-label="Warning_full_orange"
    viewBox="0 0 20 20"
    {...props}
  >
    <g className="Warning_full_orange_svg__Icons/warning Warning_full_orange_svg__full Warning_full_orange_svg__orange">
      <g className="Warning_full_orange_svg__Group Warning_full_orange_svg__1261153670">
        <circle
          cx={10}
          cy={10}
          r={8}
          fill="var(--dataviz-color-status-primary-warning)"
          className="Warning_full_orange_svg__Ellipse Warning_full_orange_svg__1934"
        />
        <path
          fill="var(--color-content-inverted-base-primary)"
          d="M11 13.4a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-1.8-3a.8.8 0 0 0 1.6 0V6a.8.8 0 0 0-1.6 0z"
          className="Warning_full_orange_svg__Vector"
        />
      </g>
    </g>
  </svg>
);
export default SvgWarningFullOrange;
